/**
 * Closes the combobox popover on Escape.
 *
 * The wrappers open their popover as `popover="manual"`, and a manual popover does not hand
 * focus back when it hides. With `focus-filter` the caret sits in the popover's filter input,
 * so focus would drop to <body> and the next Tab would start at the top of the page. When
 * focus was inside the popover, it therefore goes back to the trigger (`.selected`).
 *
 * Escape during an IME composition only cancels the composition, as in `@o2d/popover-list`.
 */
export function closePopoverOnEscape(host: HTMLElement, evt: KeyboardEvent): void {
    if (evt.key !== 'Escape' || evt.isComposing) return;
    const popover = host.querySelector<HTMLElement>('o2d-popover-list');
    if (!popover?.matches(':popover-open')) return;
    const focusWasInPopover = popover.contains(activeElementOf(host.getRootNode()));
    popover.hidePopover();
    if (focusWasInPopover) {
        host.querySelector<HTMLElement>('.selected[tabindex]')?.focus({ preventScroll: true });
    }
}

/** The focused element of a document or shadow root; `null` for a detached subtree. */
function activeElementOf(root: Node): Element | null {
    return 'activeElement' in root ? root.activeElement as Element | null : null;
}
